import { addAlpha, useTheme, styled, keyframes } from '@algoan/deep-dive/theme';
import React from 'react';

export interface LoaderProps {
  color?: string;
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ color, className }) => {
  const theme = useTheme();

  return (
    <S.SVG className={className} width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <S.Circle
        stroke={color ?? theme.bluePeps}
        fill="none"
        strokeWidth="2"
        strokeLinecap="square"
        cx="33"
        cy="33"
        r="30"
      />
      <circle
        stroke={color ? addAlpha(color, 0.2) : addAlpha(theme.bluePeps, 0.2)}
        fill="none"
        strokeWidth="2"
        strokeLinecap="square"
        cx="33"
        cy="33"
        r="30"
      ></circle>
    </S.SVG>
  );
};

const rotation = keyframes`
    0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(270deg);
  }
`;

const turn = keyframes`
  0% {
    stroke-dashoffset: 160;
  }

  50% {
    stroke-dashoffset: 45;
    transform: rotate(135deg);
  }

  100% {
    stroke-dashoffset: 160;
    transform: rotate(450deg);
  }
`;

const S = {
  SVG: styled.svg`
    animation: ${rotation} 1.8s linear infinite;
  `,
  Circle: styled.circle`
    stroke-dasharray: 180;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: ${turn} 1.8s ease-in-out infinite;
  `,
};
